import React from 'react';
import '../../components/css/popupstyle.css';
import { userService } from '../../_services';
import $ from 'jquery';
import CopyIcon from '../.././components/css/dark/img/theme-images/copy-regular.svg';
import copy from "copy-to-clipboard";

class AdvanceSetting extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            error: '',
            userdata: JSON.parse(localStorage.getItem('user')),
            loader: false,
            btnLoader: false,
            WhAdvanceSetting: [],
            copyID: 'Copy List Id',
            copyName: 'Copy List Name',
            errorCount: 0
        }
        this.Broker = React.createRef();
        this.isAddBrokerHS = React.createRef();
        this.isAddBrokerKlaviyo = React.createRef();
        this.WhCC = React.createRef();
        this.PricingEndpoint = React.createRef();
        this.DataEndpoint = React.createRef();
        this.EnrollEndpoint = React.createRef();
        this.BrokerEndpoint = React.createRef();
        this.BrokerEmail = React.createRef();
        this.credentialEmail = React.createRef();
        this.PharmacyEndpoint = React.createRef();
        this.PassesEndpoint = React.createRef();
        
    }
    componentDidMount() {
        setTimeout(function () {
            $(".checked").prop("checked", true);
            $('.popup').addClass('mfp-ready');
            $('.popup').addClass('mfp-bg');
            $('.popup').addClass('mfp-with-anim');
        }, 600);
        this.fetchAdvanceSetting(this.state.userdata.username, this.state.userdata.userrole, this.props.whId);
    }
    fetchAdvanceSetting(roleName, roleType, id) {
        this.setState({ loader: true });
        try {
            userService.GetAdvanceSetting(roleName, roleType, id).then(
                apidata => {
                    try {
                        if (apidata.length > 0) {
                            this.setState({ WhAdvanceSetting: apidata[0].settings[0], loader: false });
                        } else {
                            this.setState({ loader: false, error: 'Opps!, Something went wrong. Try Again.' });
                        }
                    }
                    catch (error) {
                        this.setState({ loader: false, error: 'Opps!, Something went wrong. Try Again.' });
                    }
                }
            );
        }
        catch (error) {
            this.setState({ btnLoader: false, error: 'Opps!, Something went wrong. Try Again.' });
        }
    }
    handleClose = () => {
        try {
            this.props.closeSettingPopup(this.props.whName, this.props.whId, this.props.whPrefix, this.props.whProfilePagin, this.props.whSearch);
            this.props.openEditProfilePopup(this.props.whName, this.props.whId, this.props.whPrefix, this.props.whProfilePagin, this.props.whSearch);
        }
        catch (error) {
            this.setState({ error: 'Error, Try again' });
        }
    }
    handleSaveSubmit = (e) => {
        try {
            // disable submit
            this.setState({ loader: false, btnLoader: true, error: '' });
            $(e.target).attr("disabled", true);
            // get input field values
            let whId = this.state.WhAdvanceSetting.whId;
            let listName = this.state.WhAdvanceSetting.listName;
            let listId = this.state.WhAdvanceSetting.listId;
            let broker;
            let wh_cc;
            let isAddBrokerHS;
            let isAddBrokerKlaviyo;
            if (this.props.isGlic == "true") {
                broker = this.Broker.current.checked;
                wh_cc = this.WhCC.current.checked;
                isAddBrokerHS = this.isAddBrokerHS.current.checked;
                isAddBrokerKlaviyo = this.isAddBrokerKlaviyo.current.checked;
            } else {
                broker = this.state.WhAdvanceSetting.isBroker;
                wh_cc = this.state.WhAdvanceSetting.isWhCC;
                isAddBrokerHS = this.state.WhAdvanceSetting.isAddBrokerHS;
                isAddBrokerKlaviyo = this.state.WhAdvanceSetting.isAddBrokerKlaviyo;
            }
            if (isAddBrokerHS == true) {
                if (broker == false) {
                    this.setState({ btnLoader: false, error: 'For enable add Brokers to Hubspot, make sure enable broker is yes' });
                    $(e.target).attr("disabled", false);
                    return;
                }
            }
            let pricing = this.PricingEndpoint.current.checked;
            let data_point = this.DataEndpoint.current.checked;
            let enroll = this.EnrollEndpoint.current.checked;
            let brokerEndpoint = this.BrokerEndpoint.current.checked;
            let brokerEmail = this.BrokerEmail.current.checked;
            let isBrokerCredEmail = this.credentialEmail.current.checked;
            let isPharmacyEndpoint = this.PharmacyEndpoint.current.checked;
            let isPassesEndpoint = this.PassesEndpoint.current.checked;
            if (brokerEndpoint == true && broker == false) {
                this.setState({ btnLoader: false, error: 'For enable dashboard end point, make sure enable broker is yes' });
                $(e.target).attr("disabled", false);
                return;
            }
            if (wh_cc == true && broker == false) {
                this.setState({ btnLoader: false, error: 'Broker should enable for allow wholesaler as CC' });
                $(e.target).attr("disabled", false);
                return;
            }
            if (this.state.errorCount == 0) {
                this.ProcessWhAdvanceSetting(whId, listId, listName, broker, wh_cc, pricing, data_point, enroll, brokerEndpoint, brokerEmail, isAddBrokerHS, isBrokerCredEmail, isAddBrokerKlaviyo, isPharmacyEndpoint, isPassesEndpoint);
                $(e.target).attr("disabled", false);
                try {
                    setTimeout(() => { this.fetchAdvanceSetting('', '', whId.toString()) }, 3000);
                    this.setState({ loader: false, btnLoader: true, error: '' });
                    $(e.target).attr("disabled", false);
                }
                catch (error) {
                }
            } else {
                this.setState({ btnLoader: false });
            }
        }
        catch (error) { }
    }
    ProcessWhAdvanceSetting = (whId, listId, listName, isBroker, isWhCC, isPricingEndpoint, isDataEndpoint, isEnrollEndpoint, isBrokerEndpoint, isBrokerWelcomeEmail, isAddBrokerHS, isBrokerCredEmail, isAddBrokerKlaviyo, isPharmacyEndpoint, isPassesEndpoint) => {
        try {
            userService.UpdatedAdvanceSetting(whId, listId, listName, isBroker, isWhCC, isPricingEndpoint, isDataEndpoint, isEnrollEndpoint, isBrokerEndpoint, isBrokerWelcomeEmail, isAddBrokerHS, isBrokerCredEmail, isAddBrokerKlaviyo, isPharmacyEndpoint, isPassesEndpoint).then(
                apidata => {
                    try {
                        if (apidata.length > 0) {
                            //this.setState({ WhAdvanceSetting: apidata[0].settings[0], btnLoader: false });
                            this.setState({ btnLoader: false, error: apidata[0].status_message });
                        } else {
                            this.setState({ btnLoader: false, error: 'Opps!, Something went wrong. Try Again.' });
                        }
                    }
                    catch (error) {
                        this.setState({ btnLoader: false, error: 'Opps!, Something went wrong. Try Again.' });
                    }
                }
            );
        }
        catch (error) {
            this.setState({ btnLoader: false, error: 'Opps!, Something went wrong. Try Again.' });
        }
    }
    copyId = (e) => {
        try {
            copy(e.target.getAttribute('data-text'));
            this.setState({ copyID: "Copied" });
            setTimeout(() => {
                this.setState({ copyID: "Copy List Id" });
            }, 600)
        }
        catch (error) { }
    }
    copyName = (e) => {
        try {
            copy(e.target.getAttribute('data-text'));
            this.setState({ copyName: "Copied" });
            setTimeout(() => {
                this.setState({ copyName: "Copy List Name" });
            }, 600)
        }
        catch (error) { }
    }
    changeStatus = (e) => {
        this.setState({ error: '' });
        let BrokerEndpoint = this.BrokerEndpoint.current.checked;
        if (BrokerEndpoint) {
            $('.col-lg-2.same').removeClass('hideBrokerEmail');
            $('.col-lg-10.same').removeClass('hideBrokerEmail');
        } else {
            $('.col-lg-2.same').addClass('hideBrokerEmail');
            $('.col-lg-10.same').addClass('hideBrokerEmail');
            $('#brokerNo').prop('checked', true);
            $('#credentialNo').prop('checked', true);            
        }
    }
    labelClick = (e) => {
        $(e.target).parents().children('input').prop("checked", true);
    }
    render() {
        const { loader, error, WhAdvanceSetting, copyID, copyName } = this.state;
        let disabled = false;
        disabled = this.state.loader ? true : false;
        return (
            <div className='popup mfp-zoom-in override-content admin-popup advance-setting-popup'>
                <div className='popup_inner manage-distributor-design'>
                    {loader &&
                        <div className="theme-loader"></div>
                    }
                    <h1>{this.props.titleText}<button onClick={this.handleClose}>X </button></h1>

                    <div className="wholesaler-section">
                        <form key={WhAdvanceSetting.whId}>
                            <div className="advanced-settings-radios">
                            {
                                this.props.isGlic == "true" ?
                                    <div className="repeat">
                                        <h2>GlicRx</h2>
                                        <div className="col-lg-2">
                                            <label>Enable Brokers</label>
                                            <div className="same">
                                                <input type="radio" ref={this.Broker} value="yes" name="Broker" className={WhAdvanceSetting.isBroker ? 'form-control checked yes radiobox' : 'form-control radiobox'} />
                                                <span onClick={this.labelClick}>Yes</span>
                                            </div>
                                            <div className="same">
                                                <input type="radio" value="no" name="Broker" className={WhAdvanceSetting.isBroker ? 'form-control radiobox' : 'form-control checked no radiobox'} />
                                                <span onClick={this.labelClick}>No</span>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 gap">
                                            <label>CC Wholesaler</label>
                                            <div className="same">
                                                <input type="radio" ref={this.WhCC} name="cc" value="yes" className={WhAdvanceSetting.isWhCC ? 'form-control checked yes radiobox' : 'form-control radiobox'} />
                                                <span onClick={this.labelClick}>Yes</span>
                                            </div>
                                            <div className="same">
                                                <input type="radio" value="no" name="cc" className={WhAdvanceSetting.isWhCC ? 'form-control radiobox' : 'form-control checked no radiobox'} />
                                                <span onClick={this.labelClick}>No</span>
                                            </div>
                                        </div>
                                        <div className="col-lg-8 send">
                                            <label>Sendgrid Details</label>
                                            <div className="same">
                                                <label>
                                                    <span className="first">List ID: </span>
                                                    <span className="second">{WhAdvanceSetting.listId}</span>
                                                    {
                                                        WhAdvanceSetting.listId != "" && WhAdvanceSetting.listId != null ?
                                                            <a href="javascript:void('0')" className="custom-tooltip">
                                                                <img data-text={WhAdvanceSetting.listId} onClick={this.copyId} src={CopyIcon} className="CopyIcon" alt="Copy Icon" />
                                                                <span className="hover-tooltip">{copyID}</span>
                                                            </a> :
                                                            null
                                                    }
                                                </label>
                                            </div>
                                            <div className="same">
                                                <label>
                                                    <span className="first">List Name: </span>
                                                    <span className="second">{WhAdvanceSetting.listName}</span>
                                                    {
                                                        WhAdvanceSetting.listName != "" && WhAdvanceSetting.listName != null ?
                                                            <a href="javascript:void('0')" className="custom-tooltip">
                                                                <img data-text={WhAdvanceSetting.listName} onClick={this.copyName} src={CopyIcon} className="CopyIcon" alt="Copy Icon" />
                                                                <span className="hover-tooltip name">{copyName}</span>
                                                            </a> :
                                                            null
                                                    }
                                                </label>
                                            </div>
                                        </div>
                                        <div className="clear"></div>
                                        <div className="col-lg-2">
                                            <label>Add Brokers to Hubspot</label>
                                            <div className="same">
                                                <input type="radio" ref={this.isAddBrokerHS} value="yes" name="isAddBrokerHS" className={WhAdvanceSetting.isAddBrokerHS  ? 'form-control checked yes radiobox' : 'form-control radiobox'} />
                                                <span onClick={this.labelClick}>Yes</span>
                                            </div>
                                            <div className="same">
                                                <input type="radio" value="no" name="isAddBrokerHS" className={WhAdvanceSetting.isAddBrokerHS ? 'form-control radiobox' : 'form-control checked no radiobox'} />
                                                <span onClick={this.labelClick}>No</span>
                                            </div>
                                        </div>
                                        <div className="col-lg-4 gap">
                                            <label>Add Brokers to Klaviyo</label>
                                            <div className="same">
                                                <input type="radio" ref={this.isAddBrokerKlaviyo} value="yes" name="isAddBrokerKlaviyo" className={WhAdvanceSetting.isAddBrokerKlaviyo ? 'form-control checked yes radiobox' : 'form-control radiobox'} />
                                                <span onClick={this.labelClick}>Yes</span>
                                            </div>
                                            <div className="same">
                                                <input type="radio" value="no" name="isAddBrokerKlaviyo" className={WhAdvanceSetting.isAddBrokerKlaviyo ? 'form-control radiobox' : 'form-control checked no radiobox'} />
                                                <span onClick={this.labelClick}>No</span>
                                            </div>
                                        </div>
                                    </div> : null
                            }

                            <div className="repeat">
                                <h2>API</h2>
                                <div className="col-lg-2">
                                    <label>Pricing Endpoint</label>
                                    <div className="same">
                                        <input type="radio" name="PricingEndPoint" ref={this.PricingEndpoint} value="yes" className={WhAdvanceSetting.isPricingEndpoint ? 'form-control checked yes radiobox' : 'form-control radiobox'} />
                                        <span onClick={this.labelClick}>Yes</span>
                                    </div>
                                    <div className="same">
                                        <input type="radio" name="PricingEndPoint" value="no" className={WhAdvanceSetting.isPricingEndpoint ? 'form-control radiobox' : 'form-control checked no radiobox'} />
                                        <span onClick={this.labelClick}>No</span>
                                    </div>
                                </div>
                                <div className="col-lg-2 gap">
                                    <label>Data Endpoint</label>
                                    <div className="same">
                                        <input type="radio" ref={this.DataEndpoint} name="dataEndPoint" value="yes" className={WhAdvanceSetting.isDataEndpoint ? 'form-control checked yes radiobox' : 'form-control radiobox'} />
                                        <span onClick={this.labelClick}>Yes</span>
                                    </div>
                                    <div className="same">
                                        <input type="radio" name="dataEndPoint" value="no" className={WhAdvanceSetting.isDataEndpoint ? 'form-control radiobox' : 'form-control checked no radiobox'} />
                                        <span onClick={this.labelClick}>No</span>
                                    </div>
                                </div>
                                <div className="col-lg-8">
                                    <label>Enrollment Endpoint</label>
                                    <div className="same">
                                        <input type="radio" ref={this.EnrollEndpoint} name="EnrollEndpoint" value="yes" className={WhAdvanceSetting.isEnrollEndpoint ? 'form-control checked yes radiobox' : 'form-control radiobox'} />
                                        <span onClick={this.labelClick}>Yes</span>
                                    </div>
                                    <div className="same">
                                        <input type="radio" name="EnrollEndpoint" value="no" className={WhAdvanceSetting.isEnrollEndpoint ? 'form-control radiobox' : 'form-control checked no radiobox'} />
                                        <span onClick={this.labelClick}>No</span>
                                    </div>
                                </div>
                                <div className="clear"></div>
                                <div className="col-lg-2">
                                    <label>Dashboard Endpoint</label>
                                    <div className="same">
                                            <input type="radio" onChange={this.changeStatus} ref={this.BrokerEndpoint} name="BrokerEndpoint" value="yes" className={WhAdvanceSetting.isBrokerEndpoint ? 'form-control checked yes radiobox' : 'form-control radiobox'} />
                                        <span onClick={this.labelClick}>Yes</span>
                                    </div>
                                    <div className="same">
                                            <input type="radio" onChange={this.changeStatus} name="BrokerEndpoint" value="no" className={WhAdvanceSetting.isBrokerEndpoint ? 'form-control radiobox' : 'form-control checked no radiobox'} />
                                        <span onClick={this.labelClick}>No</span>
                                    </div>
                                </div>
                                <div className="col-lg-2 gap">
                                    <label>Pharmacy Endpoint</label>
                                    <div className="same">
                                        <input type="radio" onChange={this.changeStatus} ref={this.PharmacyEndpoint} name="PharmacyEndpoint" value="yes" className={WhAdvanceSetting.isPharmacyEndpoint ? 'form-control checked yes radiobox' : 'form-control radiobox'} />
                                        <span onClick={this.labelClick}>Yes</span>
                                    </div>
                                    <div className="same">
                                        <input type="radio" onChange={this.changeStatus} name="PharmacyEndpoint" value="no" className={WhAdvanceSetting.isPharmacyEndpoint ? 'form-control radiobox' : 'form-control checked no radiobox'} />
                                        <span onClick={this.labelClick}>No</span>
                                    </div>
                                </div>
                                <div className="col-lg-8">
                                    <label>Passes Endpoint</label>
                                    <div className="same">
                                        <input type="radio"  ref={this.PassesEndpoint} name="PassesEndpoint" value="yes" className={WhAdvanceSetting.isPassesEndpoint ? 'form-control checked yes radiobox' : 'form-control radiobox'} />
                                        <span onClick={this.labelClick}>Yes</span>
                                    </div>
                                    <div className="same">
                                        <input type="radio"  name="PassesEndpoint" value="no" className={WhAdvanceSetting.isPassesEndpoint ? 'form-control radiobox' : 'form-control checked no radiobox'} />
                                        <span onClick={this.labelClick}>No</span>
                                    </div>
                                </div>
                                <div className="clear"></div>
                                <div className={WhAdvanceSetting.isBrokerEndpoint ? "col-lg-2 same" : "col-lg-2 same hideBrokerEmail"}>
                                    <label>Broker Welcome Email</label>
                                    <div className="same">
                                        <input type="radio" ref={this.BrokerEmail} name="BrokerEmail" value="yes" className={WhAdvanceSetting.isBrokerWelcomeEmail ? 'form-control checked yes radiobox' : 'form-control radiobox'} />
                                        <span onClick={this.labelClick}>Yes</span>
                                    </div>
                                    <div className="same">
                                        <input id="brokerNo" type="radio" name="BrokerEmail" value="no" className={WhAdvanceSetting.isBrokerWelcomeEmail ? 'form-control radiobox' : 'form-control checked no radiobox'} />
                                        <span onClick={this.labelClick}>No</span>
                                    </div>
                                </div>
                                <div className={WhAdvanceSetting.isBrokerEndpoint ? "col-lg-10 same" : "col-lg-10 same hideBrokerEmail"}>
                                    <label>Broker Credential Email</label>
                                    <div className="same">
                                        <input type="radio" ref={this.credentialEmail} name="CredentialEmail" value="yes" className={WhAdvanceSetting.isBrokerCredEmail ? 'form-control checked yes radiobox' : 'form-control radiobox'} />
                                        <span onClick={this.labelClick}>Yes</span>
                                    </div>
                                    <div className="same">
                                        <input id="credentialNo" type="radio" name="CredentialEmail" value="no" className={WhAdvanceSetting.isBrokerCredEmail ? 'form-control radiobox' : 'form-control checked no radiobox'} />
                                        <span onClick={this.labelClick}>No</span>
                                    </div>
                                </div>
                            </div>
                            </div>
                            <div className="button-section">
                                {
                                    this.state.btnLoader ? <div className="theme-loader btn-profile-loader"></div> : null
                                }
                                <input type="button" disabled={disabled} onClick={this.handleSaveSubmit} className={this.state.btnLoader ? 'btn save animated-btn' : 'btn save'} value="Save" />
                                <input type="button" disabled={disabled} onClick={this.handleClose} className="btn cancel" value="Cancel" />
                                {error &&
                                    <div className={'alert alert-danger left-gap'}>{error}</div>
                                }
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        )
    }
}
export default AdvanceSetting;